import React, { useContext } from "react";
import { apolloSpaceInset3X, apolloSpaceInline1X, apolloSpaceInline1HalfX } from "@nexthink/apollo-tokens";
import { ThemeContext } from "../../theme/ThemeProvider";
import Text from "../text/Text";
import Flex from "../box/Flex";
import Box from "../box/Box";
const DialogFooter = ({ id, "data-insights": insightsAttr, message, actions }) => {
    const themeContext = useContext(ThemeContext);
    const renderActions = () => {
        return actions.map((b, i) => {
            return i > 0 ? (React.createElement(Box, { key: `DialogFooterBox${i}`, ml: apolloSpaceInline1X }, b)) : (b);
        });
    };
    return (React.createElement(Flex, { justifyContent: "space-between", flexShrink: 0, py: message || actions ? apolloSpaceInset3X : apolloSpaceInline1HalfX },
        message && (React.createElement(Text, { id: `${id}-message`, "data-insights": insightsAttr && `${insightsAttr}-message`, color: themeContext.colors.apolloColorTextError }, message)),
        actions && (React.createElement(Flex, { id: `${id}-actions`, "data-insights": insightsAttr && `${insightsAttr}-actions`, ml: "auto" }, Array.isArray(actions) ? renderActions() : actions))));
};
export default DialogFooter;
//# sourceMappingURL=DialogFooter.js.map